import React from 'react';
import { useLandingContent, resolveImageUrl } from '../useLandingContent';

export default function ChiSiamo() {
  const { content } = useLandingContent();
  const COMPANY = content.company;
  const cs = content.chi_siamo || {};
  const customPara = (cs.paragrafo || '').trim();
  const customFoto = (cs.foto || '').trim();
  return (
    <section id="chi-siamo" className="py-20 sm:py-28 bg-stone-950 text-white relative overflow-hidden" data-testid="section-chi-siamo">
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '32px 32px' }} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-[11px] font-black text-primary uppercase tracking-widest mb-3">— Chi Siamo</p>
          <h2 className="text-3xl sm:text-5xl font-black tracking-tight mb-6 leading-[1.1]">
            Due generazioni,<br />
            <span className="text-primary">una sola visione del lavoro ben fatto.</span>
          </h2>
          <div className="space-y-4 text-stone-300 text-lg leading-relaxed">
            {customPara ? (
              <p className="whitespace-pre-line">{customPara}</p>
            ) : (
              <>
                <p>
                  EDIL CIMA nasce <strong className="text-white">agli inizi degli anni 2000</strong> fondata sulla vasta esperienza sul campo del titolare <strong className="text-white">Germano Cima</strong>. Nel <strong className="text-white">2021</strong> il figlio <strong className="text-white">Simone</strong> entra nella compagine sociale, portando metodo, tecnologia e una nuova generazione di servizi.
                </p>
                <p>
                  Oggi siamo una realtà altamente affidabile che offre servizi di <strong className="text-white">costruzione, ristrutturazione, realizzazione piscine, sistemazione tetti e manutenzioni</strong> di elevata qualità. Conosciamo il valore dei vostri immobili e ci impegniamo quotidianamente perché possano mantenerlo e incrementarlo.
                </p>
                <p>
                  Tutti i lavori sono <strong className="text-primary">certificati e seguiti da professionisti del settore</strong>: impianti elettrici e idraulici, personalizzazione delle finiture, posa di pavimenti e rivestimenti, cartongesso e finiture d'interni.
                </p>
              </>
            )}
          </div>

          <div className="mt-10 grid grid-cols-2 gap-4 max-w-md">
            <Pillar number="20+" label="Anni di attività" />
            <Pillar number="2" label="Generazioni in cantiere" />
            <Pillar number="100%" label="Lavori certificati" />
            <Pillar number="0€" label="Sopralluogo e preventivo" />
          </div>
        </div>

        <div className="relative">
          <div className="aspect-[4/5] rounded-lg overflow-hidden shadow-2xl">
            <img src={customFoto ? resolveImageUrl(customFoto) : '/chi_siamo_hero.webp'}
              alt={`${(COMPANY.team || []).join(' e ')}, titolari di EDIL CIMA S.R.L. a Calcinato`}
              loading="lazy" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 bg-primary text-white p-5 sm:p-6 rounded-lg shadow-2xl max-w-xs">
            <p className="text-3xl sm:text-4xl font-black leading-none">Cima</p>
            <p className="text-xs sm:text-sm font-semibold mt-1 opacity-90">Germano & Simone<br />Padre e figlio in cantiere.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

function Pillar({ number, label }) {
  return (
    <div className="border-l-2 border-primary pl-4">
      <p className="text-3xl font-black">{number}</p>
      <p className="text-xs text-stone-400 font-semibold uppercase tracking-wider">{label}</p>
    </div>
  );
}
